var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"clock"},[_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.formattedTime))]),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.formattedDate))])])])}
var staticRenderFns = []

export { render, staticRenderFns }